<template>
    <nav class="navbar-light bg-white shadow-sm" @mouseenter="cancelMouseLeaveTimer()" @mouseleave="clearClickedMenu()">
        <div class="container-fluid">
            <div class="row">
                <div class="col-2 border-right">
                    <div class="border-bottom">
                        <a class="navbar-brand" :href="menuRoutes['root']">
                            <img width="123" src="/images/mar-logo-default.svg">
                        </a>
<!--                         <button class="navbar-toggler d-none" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="{{ __('Toggle navigation') }}">-->
<!--                            <span class="navbar-toggler-icon"></span>-->
<!--                        </button>-->
                    </div>
                    <div v-if="userPermissions.includes('access.admin')" class="">
                        <a class="navbar-brand" href="">
                            Admin Panel
                        </a>
                    </div>
                    <div v-else class="">
                        <a class="navbar-brand" href="">
                            &nbsp;
                        </a>
                    </div>
                </div>
                <div class="col-8">
                    <div>
                        <ul class="nav justify-content-center">
                            <li v-if="isAdmin || userPermissions.includes('access.course-categories-management')
                                        || userPermissions.includes('access.courses-management')
                                        || userPermissions.includes('access.quizzes-management')"
                                class="nav-item"
                                @click="setClickedMenu('courseCreator')">
                                <a class="nav-link"
                                   :class="{ active: menuActive.first.courseCreator }"
                                   href="#">{{trans('navbar.Course Manager')}}</a>
                            </li>
                            <li v-if="isAdmin || userPermissions.includes('access.user-management')
                                        || userPermissions.includes('access.role-management')
                                        || userPermissions.includes('access.permission-management')
                                        || userPermissions.includes('access.student-group-management')
                                        || userPermissions.includes('access.training-management')"
                                class="nav-item"
                                @click="setClickedMenu('dataRelation')">
                                <a class="nav-link"
                                   :class="{ active: menuActive.first.dataRelation }"
                                   href="#">{{trans('navbar.Data & Relation Manager')}}</a>
                            </li>
                            <li v-if="isAdmin || userPermissions.includes('access.general-settings')
                                        || userPermissions.includes('access.layout-settings')
                                        || userPermissions.includes('access.language-settings')"
                                class="nav-item"
                                @click="setClickedMenu('settings')">
                                <a class="nav-link"
                                   :class="{ active: menuActive.first.settings }"
                                   href="#">{{trans('navbar.Settings')}}</a>
                            </li>
                            <li v-if="isAdmin || userPermissions.includes('access.courses-management')"
                                class="nav-item">
                                <a class="nav-link"
                                   :class="{ active: menuActive.first.students }"
                                   :href="menuRoutes['students']">{{trans('navbar.students')}}</a>
                            </li>
                            <li v-if="isAdmin || userPermissions.includes('access.courses-management')"
                                class="nav-item">
                                <a class="nav-link"
                                   :class="{ active: menuActive.first.essays }"
                                   :href="menuRoutes['essays']">{{trans('navbar.essays')}}</a>
                            </li>
                            <li v-if="isAdmin || userPermissions.includes('access.library')"
                                class="nav-item"
                                @click="setClickedMenu('library')">
                                <a class="nav-link"
                                   :class="{ active: menuActive.first.library }"
                                   href="#">{{trans('navbar.My Library')}}</a>
                            </li>
                            <template v-if="!isAdmin">
                                <li v-if="isAdmin || userPermissions.includes('access.course-categories')"
                                    class="nav-item">
                                    <a class="nav-link"
                                       :class="{ active: menuActive.first.CourseCategories }"
                                       :href="menuRoutes['course-categories']">{{trans('navbar.Course Categories')}}</a>
                                </li>
                                <li v-if="isAdmin || userPermissions.includes('access.courses')"
                                    class="nav-item">
                                    <a class="nav-link"
                                       :class="{ active: menuActive.first.Courses }"
                                       :href="menuRoutes['courses']">{{trans('navbar.Courses')}}</a>
                                </li>
                                <li v-if="isAdmin || userPermissions.includes('access.my-courses')"
                                    class="nav-item">
                                    <a class="nav-link"
                                       :class="{ active: menuActive.first.MyCourses }"
                                       :href="menuRoutes['my-courses']">{{trans('navbar.My Courses')}}</a>
                                </li>
                                <li v-if="userPermissions.length > 0 && (!isAdmin || !userPermissions.includes('access.edit.course'))"
                                    class="nav-item">
                                    <a class="nav-link"
                                       :class="{ active: menuActive.first.userCertificates }"
                                       :href="menuRoutes['user-certificates']">Certificates</a>
                                </li>
                            </template>
                        </ul>
                    </div>
                    <div>
                        <ul v-show="(menuActive.first.courseCreator  && hoveredMenu === '' )|| hoveredMenu === 'courseCreator'"
                            class="nav justify-content-center">
                            <li v-if="isAdmin ||userPermissions.includes('access.course-categories-management')" class="nav-item">
                                <a class="nav-link"
                                   :class="{active: menuActive.second.categories}"
                                   :href="menuRoutes['course-categories-management']">{{trans('navbar.Course Categories Management')}}</a>
                            </li>
                            <li v-if="isAdmin ||userPermissions.includes('access.courses-management')" class="nav-item">
                                <a class="nav-link"
                                   :class="{active: menuActive.second.courses}"
                                   :href="menuRoutes['courses-management']">{{trans('navbar.Course Creator')}}</a>
                            </li>
                            <li v-if="isAdmin ||userPermissions.includes('access.quizzes-management')" class="nav-item">
                                <a class="nav-link"
                                   :class="{active: menuActive.second.quizzes}"
                                   :href="menuRoutes['quizzes']">{{trans('navbar.Quiz Creator')}}</a>
                            </li>
                            <li v-if="isAdmin || userPermissions.includes('access.certificates-management')" class="nav-item">
                                <a class="nav-link"
                                    :class="{active: menuActive.second.certifications}"
                                    :href="menuRoutes['certifications-management']">
                                    {{trans('navbar.Certifications Creator')}}
                                </a>
                            </li>
                            <li v-if="0" class="nav-item"><a class="nav-link" href="#">{{trans('navbar.Examination Creator')}}</a></li>
                        </ul>
                        <ul v-show="(menuActive.first.dataRelation && hoveredMenu === '' ) || hoveredMenu === 'dataRelation'"
                            class="nav justify-content-center">
                            <li v-if="isAdmin ||userPermissions.includes('access.training-management')" class="nav-item">
                                <a class="nav-link"
                                   :class="{active: menuActive.second.trainingPlanning}"
                                   :href="menuRoutes['training-management']">{{trans('navbar.Training Planning')}}</a>
                            </li>
                            <li v-if="isAdmin ||userPermissions.includes('access.course-event-management')" class="nav-item">
                                <a class="nav-link"
                                   :class="{active: menuActive.second.courseEvent}"
                                   :href="menuRoutes['course-event-management']">{{trans('navbar.Course Event Management')}}</a>
                            </li>
                            <li v-if="isAdmin ||userPermissions.includes('access.student-group-management')" class="nav-item">
                                <a class="nav-link"
                                   :class="{active: menuActive.second.studentGroup}"
                                   :href="menuRoutes['student-group-management']">{{trans('navbar.Student Group Management')}}</a>
                            </li>
                            <li v-if="isAdmin ||userPermissions.includes('access.users-management')" class="nav-item">
                                <a class="nav-link"
                                   :class="{active: menuActive.second.user}"
                                   :href="menuRoutes['users-management']">{{trans('navbar.User Management')}}</a>
                            </li>
                            <li v-if="isAdmin ||userPermissions.includes('access.roles-management')" class="nav-item">
                                <a class="nav-link"
                                   :class="{active: menuActive.second.role}"
                                   :href="menuRoutes['roles-management']">{{trans('navbar.Role Management')}}</a>
                            </li>
                            <li v-if="isAdmin ||userPermissions.includes('access.permissions-management')" class="nav-item">
                                <a class="nav-link"
                                   :class="{active: menuActive.second.permission}"
                                   :href="menuRoutes['permissions-management']">{{trans('navbar.Permission Management')}}</a>
                            </li>
                        </ul>
                        <ul v-show="(menuActive.first.settings && hoveredMenu === '' ) || hoveredMenu === 'settings'"
                            class="nav justify-content-center">
                            <li v-if="isAdmin ||userPermissions.includes('access.general-settings')" class="nav-item">
                                <a class="nav-link"
                                   :class="{active: menuActive.second.general}"
                                   :href="menuRoutes['general-settings']">{{trans('navbar.General')}}</a>
                            </li>
                            <li v-if="isAdmin ||userPermissions.includes('access.layout-settings')" class="nav-item">
                                <a class="nav-link"
                                   :class="{active: menuActive.second.layout}"
                                   :href="menuRoutes['layout-settings']">{{trans('navbar.Layout')}}</a>
                            </li>
                            <li v-if="isAdmin ||userPermissions.includes('access.form-fields-settings')" class="nav-item">
                                <a class="nav-link"
                                   :class="{active: menuActive.second.formFields}"
                                   :href="menuRoutes['form-fields-settings']">{{trans('navbar.Form Fields')}}</a>
                            </li>
                            <li v-if="isAdmin ||userPermissions.includes('access.email-settings')" class="nav-item">
                                <a class="nav-link"
                                   :class="{active: menuActive.second.emailSettings}"
                                   :href="menuRoutes['email-settings']">{{trans('navbar.Email Settings')}}</a>
                            </li>
                            <li v-if="isAdmin ||userPermissions.includes('access.language-settings')" class="nav-item">
                                <a class="nav-link"
                                   :class="{active: menuActive.second.language}"
                                   :href="menuRoutes['language-settings']">{{trans('navbar.Language')}}</a>
                            </li>
                        </ul>
                        <ul v-show="(menuActive.first.library && hoveredMenu === '' ) || hoveredMenu === 'library'"
                            class="nav justify-content-center">
                            <li v-if="isAdmin ||userPermissions.includes('access.library')" class="nav-item">
                                <a class="nav-link"
                                   :class="{active: menuActive.second.images}"
                                   :href="menuRoutes['library.images']">{{trans('navbar.Images Library')}}</a>
                            </li>
                            <li v-if="isAdmin ||userPermissions.includes('access.library')" class="nav-item">
                                <a class="nav-link"
                                   :class="{active: menuActive.second.audio}"
                                   :href="menuRoutes['library.audio']">{{trans('navbar.Audio Library')}}</a>
                            </li>
                            <li v-if="isAdmin ||userPermissions.includes('access.library')" class="nav-item">
                                <a class="nav-link"
                                   :class="{active: menuActive.second.videos}"
                                   :href="menuRoutes['library.videos']">{{trans('navbar.Videos Library')}}</a>
                            </li>
                            <li v-if="isAdmin ||userPermissions.includes('access.library')" class="nav-item">
                                <a class="nav-link"
                                   :class="{active: menuActive.second.documents}"
                                   :href="menuRoutes['library.documents']">{{trans('navbar.Documents Library')}}</a>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="col-2 border-left">
                    <ul class="nav justify-content-end border-bottom">
                        <template v-if="Object.keys(user).length === 0">
                            <li  class="nav-item">
                                <a class="nav-link" :href="menuRoutes['login']">{{trans('navbar.Login')}}</a>
                            </li>
                            <li v-if="menuRoutes['register'] !== undefined" class="nav-item">
                                <a class="nav-link" :href="menuRoutes['register']">{{trans('navbar.Register')}}</a>
                            </li>
                        </template>
                        <template v-else>
                            <li class="nav-item dropdown">
                                <a id="navbarDropdown" class="nav-link dropdown-toggle user-right-menu" href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                    <div class="avatar-wrapper">
                                        <img class="avatar" :src="menuRoutes['user-avatar']"/>
                                    </div>
                                    {{ user.first_name }} {{user.last_name}}
                                </a>
                                <div class="dropdown-menu dropdown-menu-right" aria-labelledby="navbarDropdown">
                                    <a class="dropdown-item" :href="menuRoutes['profile']">
                                        {{ trans('navbar.Profile') }}
                                    </a>
                                    <a class="dropdown-item" :href="menuRoutes['logout']"
                                       onclick="event.preventDefault();
                                                         document.getElementById('logout-form').submit();">
                                        {{ trans('navbar.Logout') }}
                                    </a>

                                    <form id="logout-form" :action="menuRoutes['logout']" method="POST" class="d-none">
                                        <input type="hidden" name="_token" :value="csrf">
                                    </form>
                                </div>
                            </li>
                        </template>
                    </ul>
                    <div v-if="currentRoute ==='course-creator'" class="course-creator-buttons">
                        <a href="#" target="_blank" class="preview-mobile">
                            <img class="mt-1 mr-2" height="30" src="/images/marLMS-phone-view.png">
                        </a>
                        <a href="#" target="_blank" class="preview-tablet">
                            <img class="mt-1 mr-2 " height="30" src="/images/marLMS-tablet-view.png">
                        </a>
                        <a href="#" target="_blank" class="preview-notebook">
                            <img class="mt-1 mr-2" height="30" src="/images/marLMS-notebook.png">
                        </a>
                        <a href="#" target="_blank" class="preview-desktop">
                            <img  class="mt-1 mr-2" height="30" src="/images/marLMS-pc-view.png">
                        </a>
                        <div class="analog-clock-container pointer">
                            <world-clock :icon-mode="true" @click="showWorldClocks=true"></world-clock>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <world-clocks-modal v-if="showWorldClocks" @modal-closed="showWorldClocks=false"></world-clocks-modal>
    </nav>
</template>

<script>
import WorldClocksModal from "./CourseParts/WorldClocksModal";
import WorldClock from "./CourseParts/WorldClock";
export default {
    name: "NavBar",
    components: {WorldClock, WorldClocksModal},
    props: {
        userPermissions: {
            type: Array,
            default: () => [],
        },
        menuActive: {
            type: Object,
            default: () => {},
        },
        firstMenuActive: {
            type: String,
            default: '',
        },
        menuRoutes: {
            type: Object,
            default: () => {}
        },
        currentRoute: {
            type: String,
            default: ''
        },
        user : {
            type: Object,
            default: () => {}
        },
    },
    methods: {
        clearClickedMenu : function () {
            const self = this
            this.mouseLeaveTimer = setInterval(function(){
                self.hoveredMenu = ''
                for (let menuItem in self.menuActive.first) {
                    self.menuActive.first[menuItem] = false
                }
                self.menuActive.first[self.firstMenuActive] = true;
                }, 1000);
        },
        cancelMouseLeaveTimer : function () {
            clearInterval(this.mouseLeaveTimer)
        },
        setClickedMenu : function(menu) {
            this.hoveredMenu = menu
            for (let menuItem in this.menuActive.first) {
                this.menuActive.first[menuItem] = false
            }
            //this.menuActive.first[this.firstMenuActive] = true;
            if (menu.length) {
                this.menuActive.first[menu] = true
            }
        }
    },
    data: () => ({
        csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
        hoveredMenu: '',
        mouseLeaveTimer : null,
        showWorldClocks: false,
    }),
    computed: {
        isAdmin () {
            return this.userPermissions.includes('access.admin')
        },
    }
}
</script>

<style lang="scss" scoped>
.user-right-menu {
    display: flex;
    align-items: center;
}
.avatar-wrapper {
    max-width: 25px;
    max-height: 25px;
    margin-right: 0.5em;
    margin-bottom: 0;
}

.course-creator-buttons {
    display: flex;
    align-items: flex-end;

}

</style>
